import logo from "./logo.svg";
import "./App.css";
import KengyCexDevelopment from "./components/Donation";

function App() {
  return (
    <div className="App bg-[#e5f7f9]">
      <div>
        <KengyCexDevelopment />
      </div>
    </div>
  );
}

export default App;
